import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCartContext } from '../../context/CartContext';
import { CartPreviewUI } from './CartPreviewUI';
import { GtmService } from "../../../infrastructure/analytics/GtmService";
import { useParkCart } from '../../application/useParkCart';
import { useUserContext } from '../../../user/infrastructure/UserContext';


export function CartPreview({ setModalCar }) {
  const { cart, loading, loadCart, removeProduct, loadCartBis } = useCartContext();
  const user = useUserContext();
  const { parkCart, parking } = useParkCart(loadCartBis);
  const navigate = useNavigate();

  useEffect(() => {
    loadCart();
  }, [loadCart]);

  const navigateTo = (path) => {
    navigate(path);
    setModalCar(null);
  }

  const handlePlaceOrder = () => {
    GtmService.logBeginCheckout(cart);
    navigateTo('/checkout');
  }

  return (
    <CartPreviewUI cart={cart}
      loading={loading}
      onCatalogClick={() => navigateTo('/articulos')}
      onEditProduct={(product) => navigateTo(`/articulos/${encodeURIComponent(product.code)}`)}
      onDeleteProduct={(product) => removeProduct(product)}
      onPlaceOrder={handlePlaceOrder}
      onParkCart={user?.isComercial === true ? parkCart : undefined}
      parking={parking}
    />
  );
}